import * as React from 'react'
import BaseIcon from 'react-icon-base'

const FireEmoji = props => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="12" cy="12" r="12" fill="#FFA348" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.233 18.5l-.562-.104C9.401 18.162 7 17.028 7 14.41c0-2.155 1.02-3.386 2.202-4.812.902-1.088 1.924-2.322 2.83-4.27l.384-.827.368.835c.046.102 1 2.296 1.21 5.27.575-.826.887-1.593.892-1.603l.368-.914.394.901c.098.223 2.369 5.479.803 8.043-.555.91-1.497 1.37-2.798 1.37h-.202l-.125-.167a11.184 11.184 0 0 1-1.943-4.239c-.504 1.681-.23 3.883-.227 3.91l.077.594z"
      />
    </g>
  </BaseIcon>
)

export default FireEmoji
